import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthguardServiceService } from '../Shared/authguard-service.service';
 

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {

  constructor(
    private authService: AuthguardServiceService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.authService.getToken()) {
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}
